import React, { useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { resetPassword } from "helpers/API Calls/Auth and Profile/auth";
import SM_LOGO from 'assets/images/logo/logo-small.png'

const ResetPassword = () => {

    const [reqResponse, setReqResponse] = useState<any>(null); 
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    const email = searchParams.get('email');

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            email: email,
            password: '',
            confirmPassword: "", 
        },
        validationSchema: Yup.object({
            email: Yup.string()
            .email("Please enter a valid email address")
            .required("Please Enter Your Email"),
            password: Yup.string()
                .min(8, 'Password must be at least 8 characters')
                .matches(RegExp('(.*[a-z].*)'), 'Password must have at least one lowercase letter')
                .matches(RegExp('(.*[A-Z].*)'), 'Password must have at least one uppercase letter')
                .matches(RegExp('(.*[0-9].*)'), 'Password must have at least one number')
                .required("Please Enter New Password"),
            confirmPassword: Yup.string().oneOf([Yup.ref('password')], 'Passwords must match').required("Please Confirm Your Password"),
        }),
        onSubmit: async (values: any, { setSubmitting }) => {
            const data = {
                email: values.email, 
                password: values.password, 
                confirm_password: values.confirmPassword, 
                token: token
              }
            const response = await resetPassword(data); 
            if(response){setReqResponse(response); setSubmitting(false);}
            if (response.success) {validation.resetForm()}
            return;
          }
    });


return (
<React.Fragment>
    <div className="account-pages vh-100">
    <Container className="vh-100">
        <Row className="justify-content-center h-100 align-items-center w-100">
        <Col xl={4} md={8} lg={6} className="my-auto">
            <Card>
            <div className="auth-avatar-container">
                <div className="auth-logo">
                <Link to="/">
                    <div className="avatar-md profile-user-wid mb-4">
                    <span className="avatar-title rounded-circle bg-light">
                        <img
                        src={SM_LOGO}
                        alt=""
                        className="rounded-circle"
                        height="34"
                        />
                    </span>
                    </div>
                </Link>
                </div>
            </div>
            <CardBody className="pt-5">
                <h2 className="fw-bold">Reset Password</h2>
                <div className="p-2">
                    {reqResponse && (
                        <Alert color={reqResponse.success ? "success" : "danger"} style={{ marginTop: "13px" }}>
                            {reqResponse.message}
                        </Alert>
                    )}

                    <Form className="form-horizontal" onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false;}}>

                        <div className="mb-3">
                            <Label className="form-label">Email</Label>
                            <Input
                                name="email"
                                className="form-control"
                                placeholder="Enter email"
                                type="email"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={validation.touched.email && !!validation.errors.email}
                            />
                            {validation.touched.email && validation.errors.email ? (
                                <FormFeedback type="invalid">{typeof validation.errors.email === 'string' && validation.errors.email}</FormFeedback>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <Label className="form-label">New Password</Label>
                            <Input
                                name="password"
                                className="form-control"
                                placeholder="Enter New Password"
                                type="password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.password || ""}
                                invalid={validation.touched.password && !!validation.errors.password}
                            />
                            {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid">
                                {typeof validation.errors.password === 'string' && validation.errors.password}
                            </FormFeedback>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <Label className="form-label">Confirm Password</Label>
                            <Input
                                name= "confirmPassword"
                                className="form-control"
                                placeholder="Confirm Password"
                                type= "password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.confirmPassword || ""}
                                invalid={validation.touched.confirmPassword && !!validation.errors.confirmPassword}
                            />
                            {validation.touched.confirmPassword && validation.errors.confirmPassword ? (
                            <FormFeedback type="invalid">
                                {typeof validation.errors.confirmPassword === 'string' && validation.errors.confirmPassword}
                            </FormFeedback>
                            ) : null}
                        </div>

                        <Row className="mb-3">
                            <Col className="text-end d-grid">
                                <button className="btn btn-primary w-md " type="submit" disabled={validation.isSubmitting}>{validation.isSubmitting ? 'Sending...' : 'Send Reset Email'}</button>
                            </Col>
                        </Row>
                        
                    </Form>
                    <div className="mt-4 text-center text-muted">
                        Go back to 
                        <Link to="/login" className="ms-1 text-primary">
                        Login
                        </Link>
                        .
                    </div>
                </div>
            </CardBody>
        </Card>
        </Col>
        </Row>
    </Container>
    </div>
</React.Fragment>
    );
};

export default ResetPassword;